import resellerBusinessService from "../services/partner/reseller/business";
import whitelabelBusinessService from "../services/partner/whitelabel/business";

export default {
  namespaced: true,
  state: {
    businessFetchError: null,
    businessList: [],
    businessFetchWaiting: true,
    totalBusinessCount: 0,
    premiumBusinessCount: 0,
    loadedBusinessList: {},
    allWhitelabelBusinesses: [],
  },
  getters: {
    businessList: (state) => state.businessList,
    businessFetchError: (state) => state.businessFetchError,
    businessFetchWaiting: (state) => state.businessFetchWaiting,
    loadedBusinessList: (state) => state.loadedBusinessList,
    totalBusinessCount: (state) => state.totalBusinessCount,
    premiumBusinessCount: (state) => state.premiumBusinessCount,
    allWhitelabelBusinesses: (state) => state.allWhitelabelBusinesses,
  },
  mutations: {
    setBusinessList(state, businesses) {
      state.businessFetchWaiting = false;
      state.businessList = businesses;
    },
    setBusinessFetchError(state, message) {
      state.businessFetchWaiting = false;
      state.businessFetchError = message;
    },
    setLoadedBusinessList(state, { page, businesses }) {
      state.loadedBusinessList[page] = businesses;
    },
    clearAllBusinesses(state) {
      state.businessList = [];
      state.loadedBusinessList = {};
      state.businessFetchError = null;
      state.businessFetchWaiting = true;
      state.totalBusinessCount = 0;
      state.premiumBusinessCount = 0;
    },
    setTotalBusinessCount(state, total) {
      state.totalBusinessCount = total;
    },
    setPremiumBusinessCount(state, premium) {
      state.premiumBusinessCount = premium;
    },
    setAllWhitelabelBusinesses(state, businesses) {
      state.allWhitelabelBusinesses = businesses;
    }
  },
  actions: {
    async fetchBusinesses({ commit }, { activeAccount, bId, options }) {
      if(!options)
      {
        options = {
          sortDesc: false,
          sortBy: [],
          page: 1,
          itemsPerPage: 100,
          multiSort: false,
          mustSort: false,
          groupBy: [],
          groupDesc: [],
        };
      }
      try {
        if (!activeAccount) throw new Error("Bad State");
        let businesses = [];
        if (activeAccount.type == "whitelabel")
          businesses = await whitelabelBusinessService.getWhitelabelBusinesses(
            {
              wlId: activeAccount.id,
              bId,
              options
            }
          );
        else if (activeAccount.type == "reseller") {
          businesses = await resellerBusinessService.getResellerBusinesses(
            {
              resellerId: activeAccount.id,
              bId,
              options
            }
          );
        }
        commit("setBusinessList", businesses);
        commit("setLoadedBusinessList", { page: options.page, businesses });
      } catch (error) {
        console.error(error);
        commit("setBusinessFetchError", error.message);
      }
    },
    async fetchBusinessCounts ({ commit }, { activeAccount }) {
      if (!activeAccount) throw new Error("Bad State");
      let countResponse = null;
      if (activeAccount.type == "whitelabel"){
        countResponse = await whitelabelBusinessService.getWhitelabelBusinessesCount(activeAccount.id);
      }
      else if (activeAccount.type == "reseller") {
        countResponse = await resellerBusinessService.getResellerBusinessesCount(activeAccount.id);
      }
      commit("setTotalBusinessCount", countResponse.total);
      commit("setPremiumBusinessCount", countResponse.premium);
    },
    async clearAllBusinesses({ commit }) {
      commit("clearAllBusinesses");
    },
    async setBusinessList({ state, commit }, businesses) {
      state.businessFetchWaiting = false;
      commit("setBusinessList", businesses);
    },
    async updateToPremium({ rootGetters }, { accountId, business, discountCode, period, notes }) {
      if (rootGetters["partner/activeAccountType"] == "whitelabel") {
        await whitelabelBusinessService.updateBusinessToPremium(
          accountId,
          business,
          period,
          discountCode,
          notes
        );
      }
    },
    async blockBusiness({ rootGetters }, { accountId, business, notes }) {
      if (rootGetters["partner/activeAccountType"] == "whitelabel") {
        await whitelabelBusinessService.blockBusiness(accountId, business.id, notes);
      } else {
        throw new Error("Action not permitted")
      }
    },
    async unblockBusiness({ rootGetters }, { accountId, business, notes }) {
      if (rootGetters["partner/activeAccountType"] == "whitelabel") {
        await whitelabelBusinessService.unblockBusiness(accountId, business.id, notes);
      } else {
        throw new Error("Action not permitted")
      }
    },
    async subscribeViaResellerRecharge(_x, { account, business, notes }) {
      await resellerBusinessService.subscribeViaResellerRecharge(
        account.id,
        business,
        notes
      );
    },
    async getAllWhitelabelBusinesses({ commit }, { wlId }) {
      const businesses = await whitelabelBusinessService.getAllWhitelabelBusinesses(wlId);
      commit("setAllWhitelabelBusinesses", businesses);
    }
  },
};
